import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, MapPin } from 'lucide-react';
import { nearbyAreas } from '@/data/seoLocal';

export const Footer = () => {
  const mainCities = nearbyAreas.filter(a => a.slug !== 'saint-chamond').slice(0, 12);
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-dark text-dark-foreground">
      <div className="container-custom py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="mb-5">
              <img
                src="https://customer-assets.emergentagent.com/job_crossfit-showcase/artifacts/f7rp3nhg_image.png"
                alt="CrossFit Saint-Chamond - Salle de CrossFit et HYROX 42400"
                className="h-24 w-auto rounded-lg bg-white p-2"
              />
            </div>
            <p className="text-primary text-sm font-semibold mb-1">HYROX Training Club</p>
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              Coaching sportif, encadrement professionnel, accessible à tous. Salle de CrossFit à Saint-Chamond, Loire (42).
            </p>
            <div className="flex gap-3">
              <a href="https://www.instagram.com/crossfit_saintchamond" target="_blank" rel="noopener noreferrer" aria-label="Instagram CrossFit Saint-Chamond" className="w-9 h-9 bg-white/10 hover:bg-primary rounded-lg flex items-center justify-center transition-all duration-200 hover:scale-105">
                <Instagram className="h-4 w-4" />
              </a>
              <a href="https://www.facebook.com/CrossFitSaintChamond" target="_blank" rel="noopener noreferrer" aria-label="Facebook CrossFit Saint-Chamond" className="w-9 h-9 bg-white/10 hover:bg-primary rounded-lg flex items-center justify-center transition-all duration-200 hover:scale-105">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="mailto:crossfit.saintchamond@gmail.com" aria-label="Email CrossFit Saint-Chamond" className="w-9 h-9 bg-white/10 hover:bg-primary rounded-lg flex items-center justify-center transition-all duration-200 hover:scale-105">
                <Mail className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base mb-4 text-white">Navigation</h3>
            <ul className="space-y-2.5 text-white/60 text-sm">
              <li><Link to="/" className="hover:text-primary transition-colors">Accueil</Link></li>
              <li><Link to="/programmes" className="hover:text-primary transition-colors">Programmes</Link></li>
              <li><Link to="/planning" className="hover:text-primary transition-colors">Planning</Link></li>
              <li><Link to="/tarifs" className="hover:text-primary transition-colors">Tarifs</Link></li>
              <li><Link to="/about" className="hover:text-primary transition-colors">À Propos</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base mb-4 text-white">Programmes</h3>
            <ul className="space-y-2.5 text-white/60 text-sm">
              <li><Link to="/programmes/crossfit-wod" className="hover:text-primary transition-colors">WOD CrossFit</Link></li>
              <li><Link to="/programmes/hyrox" className="hover:text-primary transition-colors">WOD HYROX</Link></li>
              <li><Link to="/programmes/team-wod" className="hover:text-primary transition-colors">WOD Team CrossFit</Link></li>
              <li><Link to="/programmes/team-hyrox" className="hover:text-primary transition-colors">WOD Team HYROX</Link></li>
              <li><Link to="/programmes/team-xl" className="hover:text-primary transition-colors">WOD Team XL</Link></li>
              <li><Link to="/programmes/free-access" className="hover:text-primary transition-colors">Free Access</Link></li>
              <li><Link to="/guide-crossfit" className="hover:text-primary transition-colors font-semibold text-primary/80">Guide du CrossFit</Link></li>
              <li><Link to="/crossfit-debutant" className="hover:text-primary transition-colors font-semibold text-primary/80">CrossFit débutant</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base mb-4 text-white">Contact</h3>
            <ul className="space-y-3 text-white/60 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-primary flex-shrink-0 mt-0.5" />
                <span>7 Rue Jean-Jacques Rousseau, 42400 Saint-Chamond</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-primary flex-shrink-0" />
                <a href="mailto:crossfit.saintchamond@gmail.com" className="hover:text-primary transition-colors">crossfit.saintchamond@gmail.com</a>
              </li>
              <li className="flex items-center gap-2">
                <Instagram className="h-4 w-4 text-primary flex-shrink-0" />
                <a href="https://www.instagram.com/crossfit_saintchamond" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">@crossfit_saintchamond</a>
              </li>
            </ul>
          </div>
        </div>

        {/* SEO Local Links */}
        <div className="py-8 border-t border-white/10 mb-8">
          <h3 className="font-heading text-sm text-white/40 mb-4 text-center">CROSSFIT ACCESSIBLE DEPUIS</h3>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2">
            {mainCities.map((city) => (
              <Link
                key={city.slug}
                to={`/crossfit/${city.slug}`}
                className="text-white/30 hover:text-primary text-xs transition-colors"
              >
                CrossFit {city.city}
              </Link>
            ))}
          </div>
        </div>

        <div className="pt-6 border-t border-white/10">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-white/40">
            <p data-testid="footer-copyright">&copy; {currentYear} CrossFit Saint-Chamond &mdash; HYROX Training Club. Salle de CrossFit 42400 Saint-Chamond, Loire.</p>
            <div className="flex gap-6">
              <Link to="/mentions-legales" className="hover:text-primary transition-colors" data-testid="footer-mentions-legales">Mentions légales</Link>
              <Link to="/confidentialite" className="hover:text-primary transition-colors" data-testid="footer-confidentialite">Confidentialité</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
